import { HttpParams } from '@angular/common/http';

export class PedidoExcelListagemOptions {
    exportValorIpi: boolean;
    exportStatusAmostra: boolean;
    exportCidadeUfPessoa: boolean;
    exportLocalDeposito: boolean;
    exportCondicaoPagamento: boolean;
    exportTipoPrazosPagamento: boolean;
    exportPrazoMedio: boolean;
    exportPercDescontoMedio: boolean;
    exportFrete: boolean;
    exportPaletizacao: boolean;
    exportPrecoFixoAte: boolean;
    exportAplicaClausulaReajuste: boolean;
    exportMotivoReprovado: boolean;
    exportCampanha: boolean;
    exportLiberacaoBonificacao: boolean;
    exportExpedicao: boolean;
    exportEcommerce: boolean;

    createParams(params: HttpParams): HttpParams {
        if (!params) {
            params = new HttpParams();
        }

        // Valor IPI
        if (this.exportValorIpi) {
            params = params.append('exportValorIpi', this.exportValorIpi.toString());
        }
        // Status Amostra
        if (this.exportStatusAmostra) {
            params = params.append('exportStatusAmostra', this.exportStatusAmostra.toString());
        }
        // Cidade e UF da Pessoa
        if (this.exportCidadeUfPessoa) {
            params = params.append('exportCidadeUfPessoa', this.exportCidadeUfPessoa.toString());
        }
        // Local de Depósito
        if (this.exportLocalDeposito) {
            params = params.append('exportLocalDeposito', this.exportLocalDeposito.toString());
        }
        // Condição de Pagamento
        if (this.exportCondicaoPagamento) {
            params = params.append('exportCondicaoPagamento', this.exportCondicaoPagamento.toString());
        }
        // Tipo e Prazos de Pagamento
        if (this.exportTipoPrazosPagamento) {
            params = params.append('exportTipoPrazosPagamento', this.exportTipoPrazosPagamento.toString());
        }
        // Prazo Médio
        if (this.exportPrazoMedio) {
            params = params.append('exportPrazoMedio', this.exportPrazoMedio.toString());
        }
        // Perc. Desconto Médio
        if (this.exportPercDescontoMedio) {
            params = params.append('exportPercDescontoMedio', this.exportPercDescontoMedio.toString());
        }
        // Frete
        if (this.exportFrete) {
            params = params.append('exportFrete', this.exportFrete.toString());
        }
        // Paletização
        if (this.exportPaletizacao) {
            params = params.append('exportPaletizacao', this.exportPaletizacao.toString());
        }
        // Preço Fixo Até
        if (this.exportPrecoFixoAte) {
            params = params.append('exportPrecoFixoAte', this.exportPrecoFixoAte.toString());
        }
        // Aplica-se Clausula Reajuste
        if (this.exportAplicaClausulaReajuste) {
            params = params.append('exportAplicaClausulaReajuste', this.exportAplicaClausulaReajuste.toString());
        }
        // Motivo Reprovado
        if (this.exportMotivoReprovado) {
            params = params.append('exportMotivoReprovado', this.exportMotivoReprovado.toString());
        }
        // Campanha
        if (this.exportCampanha) {
            params = params.append('exportCampanha', this.exportCampanha.toString());
        }
        // Liberado Bonificação
        if (this.exportLiberacaoBonificacao) {
            params = params.append('exportLiberacaoBonificacao', this.exportLiberacaoBonificacao.toString());
        }
        // Expedição
        if (this.exportExpedicao) {
            params = params.append('exportExpedicao', this.exportExpedicao.toString());
        }
        // E-commerce
        if (this.exportEcommerce) {
            params = params.append('exportEcommerce', this.exportEcommerce.toString());
        }

        return params;
    }
}
